var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "#FDFDFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5C9.88052 5 8.80285 5.42655 8.01149 6.19C7.22013 6.95036 6.77298 7.98273 6.77298 9.06145C6.77298 10.1371 7.21691 11.1695 8.00827 11.9329C8.79963 12.6933 9.8773 13.1229 10.9968 13.1229C12.1163 13.1229 13.1939 12.6933 13.9853 11.9329C14.7767 11.1725 15.2238 10.1402 15.2238 9.06145C15.2238 6.81745 13.3323 5 10.9968 5H11ZM9.24357 13.7875C6.34513 13.7875 4 16.0407 4 18.8225V20.8347C4 21.4776 4.54366 22 5.21278 22H16.7872C17.4563 22 18 21.4776 18 20.8347V18.8225C18 16.0407 15.6549 13.7875 12.7597 13.7875H9.24357Z",
    fill: "#00A90B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPro);
export default __webpack_public_path__ + "static/media/pro.3776dca55d7fff2f28e45011cecbf9f9.svg";
export { ForwardRef as ReactComponent };